import "../../App.css";
import { useEffect, useRef, useState } from "react";
import TableRow from "../../components/TableRow";
import MobileTableRow from "../../components/mobileTableRow";
import SkyLoader from "../../components/sky-loader";
import { useSelector } from "react-redux";
import Appconfig from "../../config/config";
import { useLocation } from "react-router-dom";
import OpenBets from "components/openbets";

function Inplay() {
  const userInfos = useSelector((state) => state.events); // Use selector to access state

  const [activeCasino, setActiveCasino] = useState("popular");
  const [selectedTime, setSelectedTime] = useState("inplay");
  const [allEvents, setAllEvents] = useState([]);
  const [cricketEvents, setCricketEvents] = useState([]);
  const [tennisEvents, setTennisEvents] = useState([]);
  const [soccerEvents, setSoccerEvents] = useState([]);

  useEffect(() => {
    if (userInfos?.events?.length) {
      setAllEvents(userInfos.events[0]?.competitions[0].events);
    }
  }, [userInfos?.events]);

  const [casino, setCasino] = useState(Appconfig.allCasino);
  // useEffect(() => (
  //     setCasino(activeCasino == 'popular' ? Appconfig.allCasino : Appconfig.allCasino.filter(e => e.category == activeCasino))
  // ), [activeCasino])

  useEffect(() => {
    if (activeCasino == "popular") {
      const filteredCasinos =
        Appconfig.sitecodes != "P56"
          ? Appconfig.allCasino.filter((e) => e.casino_type != "WCO")
          : Appconfig.allCasino;
      setCasino(filteredCasinos);
    } else {
      setCasino(Appconfig.allCasino.filter((e) => e.category == activeCasino));
    }
  }, [activeCasino]);

  const scrollableDivRef = useRef(null);
  const scrollToItem = (index) => {
    const itemElement = scrollableDivRef.current.querySelector(
      `#item-${index}`
    );
    if (itemElement) {
      itemElement.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  };

  useEffect(() => {
    if (allEvents.length > 0 && selectedTime == "inplay") {
      const tempCricketEvents = allEvents.filter(
        (event) => event.is_inplay == "True" && event.event_type == 4
      );
      setCricketEvents(tempCricketEvents);
      const tempTennisEvents = allEvents.filter(
        (event) => event.is_inplay == "True" && event.event_type == 2
      );
      setTennisEvents(tempTennisEvents);
      const tempSoccerEvents = allEvents.filter(
        (event) => event.is_inplay == "True" && event.event_type == 1
      );
      setSoccerEvents(tempSoccerEvents);
    }
    if (allEvents.length > 0 && selectedTime == "today") {
      const tempCricketEvents = allEvents.filter(
        (event) =>
          new Date(event.open_date).toDateString() ==
            new Date().toDateString() && event.event_type == 4
      );
      setCricketEvents(tempCricketEvents);
      const tempTennisEvents = allEvents.filter(
        (event) =>
          new Date(event.open_date).toDateString() ==
            new Date().toDateString() && event.event_type == 2
      );
      setTennisEvents(tempTennisEvents);
      const tempSoccerEvents = allEvents.filter(
        (event) =>
          new Date(event.open_date).toDateString() ==
            new Date().toDateString() && event.event_type == 1
      );
      setSoccerEvents(tempSoccerEvents);
    }
    if (allEvents.length > 0 && selectedTime == "tomorrow") {
      const tempCricketEvents = allEvents.filter(
        (event) =>
          new Date(event.open_date).toLocaleDateString() >
            new Date().toLocaleDateString() && event.event_type == 4
      );
      setCricketEvents(tempCricketEvents);
      const tempTennisEvents = allEvents.filter(
        (event) =>
          new Date(event.open_date).toDateString() >
            new Date().toDateString() && event.event_type == 2
      );
      setTennisEvents(tempTennisEvents);
      const tempSoccerEvents = allEvents.filter(
        (event) =>
          new Date(event.open_date).toDateString() >
            new Date().toDateString() && event.event_type == 1
      );
      setSoccerEvents(tempSoccerEvents);
    }
  }, [selectedTime, allEvents]);

  const location = useLocation();

  // read ?tab=today
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");

    if (tab === "today") {
      setSelectedTime("today");
    }
  }, [location]);

  return (
    <>
      {!allEvents.length > 0 && <SkyLoader />}
      {/* Desktop */}
      <div className="hidden lg:flex gap-4">
        <div className="flex-shrink-0" style={{ flexBasis: "75%" }}>
          <div className="grid grid-cols-12 ">
            <div className="col-span-12 mb-[1rem]">
              <ul className="py-[0] relative w-[42%] mx-[0] mt-[1px] mb-[0px] rounded-[5px] flex">
                <li
                  className={`rounded-tl-[4px] rounded-br-[0] rounded-tr-[0] rounded-bl-[4px] w-[33%] block border-[1px] border-[solid] border-[#3B5160] border-[1px_0]`}
                >
                  <button
                    type="button"
                    className={`rounded-tl-[3px] rounded-br-[0] rounded-tr-[0] rounded-bl-[3px] border-l-[1px_solid_#3B5160]  border-r-[1px_solid_#3B5160] text-[0.813rem] leading-[27px] block text-center font-bold cursor-pointer no-underline w-full ${
                      selectedTime == "inplay"
                        ? `bg-[#3B5160] text-[#ffffff]`
                        : `bg-[#ffffff] text-[#3B5160]`
                    }`}
                    onClick={() => setSelectedTime("inplay")}
                  >
                    In-Play
                  </button>
                </li>

                <li
                  className={`rounded-br-[0] rounded-tr-[0]  w-[33%] block border-y-[1px] border-[solid] border-[#3B5160] border-[1px_0]`}
                >
                  <button
                    type="button"
                    className={`border-r-[1px_solid_#3B5160]  text-[0.813rem] leading-[27px] block text-center font-bold cursor-pointer no-underline w-full ${
                      selectedTime == "today"
                        ? `bg-[#3B5160] text-[#ffffff]`
                        : `bg-[#ffffff] text-[#3B5160]`
                    }`}
                    onClick={() => setSelectedTime("today")}
                  >
                    Today
                  </button>
                </li>

                <li
                  className={` rounded-tl-[0] rounded-br-[4px] rounded-tr-[4px] rounded-bl-[0] w-[33%] block [list-style:none] border-[1px] border-[solid] border-[#3B5160] border-[1px_0]`}
                >
                  <button
                    type="button"
                    className={`rounded-tl-[0] rounded-br-[3px] rounded-tr-[3px] rounded-bl-[0]  border-r-[1px_solid_#3B5160]  text-[0.813rem] leading-[27px] block text-center font-bold cursor-pointer no-underline w-full ${
                      selectedTime == "tomorrow"
                        ? `bg-[#3B5160] text-[#ffffff]`
                        : `bg-[#ffffff] text-[#3B5160]`
                    }`}
                    onClick={() => setSelectedTime("tomorrow")}
                  >
                    Tomorrow
                  </button>
                </li>
              </ul>
            </div>
            {cricketEvents.length > 0 && (
              <div className="col-span-12  mb-[10px]">
                <div className="bg-[#243a48]">
                  <h3 className="bg-[#243a48] h-[25px] text-[#ffffff] text-[0.875rem] leading-[25px] font-normal pl-[10px] m-0 cursor-pointer">
                    Cricket{" "}
                  </h3>
                </div>
                <table className="w-full">
                  <thead className="bg-[#ced5da] ">
                    <tr>
                      <th scope="col" className="text-[0.688rem] "></th>
                      <th scope="col" className="text-[0.688rem] font-normal ">
                        1
                      </th>
                      <th scope="col" className="text-[0.688rem] font-normal">
                        X
                      </th>
                      <th scope="col" className="text-[0.688rem] font-normal">
                        2
                      </th>
                      <th scope="col" className="text-[0.688rem] "></th>
                    </tr>
                  </thead>
                  <tbody className="bg-[linear-gradient(-180deg,_#ffffff_0%,_#ffffff_100%)]">
                    {cricketEvents.map((event, index) => (
                      <TableRow key={index} row={event} inplay={true} />
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            {soccerEvents.length > 0 && (
              <div className="col-span-12  mb-[10px]">
                <div className="bg-[#243a48] ">
                  <h3 className="bg-[#243a48] h-[25px] text-[#ffffff] text-[0.875rem] leading-[25px] font-normal pl-[10px] m-0 cursor-pointer">
                    Soccer{" "}
                  </h3>
                </div>
                <table className="w-full">
                  <thead className="bg-[#ced5da] ">
                    <tr>
                      <th scope="col" className="text-[0.688rem] "></th>
                      <th scope="col" className="text-[0.688rem] font-normal">
                        1
                      </th>
                      <th scope="col" className="text-[0.688rem] font-normal">
                        X
                      </th>
                      <th scope="col" className="text-[0.688rem] font-normal">
                        2
                      </th>
                      <th scope="col" className="text-[0.688rem] "></th>
                    </tr>
                  </thead>
                  <tbody className="bg-[linear-gradient(-180deg,_#ffffff_0%,_#ffffff_100%)]">
                    {soccerEvents.map((event, index) => (
                      <TableRow key={index} row={event} inplay={true} />
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {tennisEvents.length > 0 && (
              <div className="col-span-12 mb-[10px]">
                <div className="bg-[#243a48] ">
                  <h3 className="bg-[#243a48] h-[25px] text-[#ffffff] text-[0.875rem] leading-[25px] font-normal pl-[10px] m-0 cursor-pointer">
                    Tennis{" "}
                  </h3>
                </div>
                <table className="w-full">
                  <thead className="bg-[#ced5da] ">
                    <tr>
                      <th scope="col" className="text-[0.688rem] "></th>
                      <th scope="col" className="text-[0.688rem] font-normal ">
                        1
                      </th>
                      <th scope="col" className="text-[0.688rem] font-normal">
                        X
                      </th>
                      <th scope="col" className="text-[0.688rem] font-normal">
                        2
                      </th>
                      <th scope="col" className="text-[0.688rem] "></th>
                    </tr>
                  </thead>
                  <tbody className="bg-[linear-gradient(-180deg,_#ffffff_0%,_#ffffff_100%)]">
                    {tennisEvents.map((event, index) => (
                      <TableRow key={index} row={event} inplay={true} />
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            {/* <div className='col-span-12 '>
                            <ul className="flex flex-nowrap overflow-x-auto overflow-y-hidden  text-sm font-medium text-center text-gray-500  [scrollbar-width:none] bg-[linear-gradient(-180deg,#14805e_0,_#184438_100%)]">
                                {Appconfig.casinoNav.map((item) => {
                                    if (Appconfig.sitecodes != "P56" && item.cainso_type == "WCO") {
                                        return null;
                                    }
                                    return (
                                        <li className="flex px-[4px] py-[2px]">
                                            <button className={`p-[7px] min-w-[60px] text-[0.75rem] font-bold whitespace-nowrap uppercase [transition:color_.15s_ease-in-out,_background-color_.15s_ease-in-out,_border-color_.15s_ease-in-out] ${activeCasino == item.category ? `text-white` : `text-black border-r-[1px] border-black rounded-[40px]`}  `} onClick={() => setActiveCasino(item.category)}>{item.title}</button>
                                        </li>
                                    )
                                })}
                            </ul>
                            <div className="grid grid-cols-12 gap-x-6 bg-[url('/public/other/casinobg.webp')] bg-contain bg-fixed p-[0.938rem] border-b-[1px] border-[#7e97a7]">
                                {
                                    casino.map((casino) => (
                                        <div className='col-span-3  rounded-[5px] mb-[15px] cursor-pointer [box-shadow:0px_2px_4px] h-[185px]'>
                                            <div className='relative h-[20vh] bg-[#14805e]  rounded-tl-[5px] rounded-tr-[5px]'>
                                                <div className='clip'></div>
                                                <div className='clip2-desktop'>
                                                    <img title="" alt="" className="w-full h-full" src={casino.path}></img>
                                                </div>
                                            </div>
                                            <div className='casinoFont-desktop w-full text-center text-[15px] rounded-bl-[5px] rounded-br-[5px] font-bold uppercase bg-[linear-gradient(-180deg,_#14805e_0,_#184438_100%)]'>
                                                {casino.title}
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div> */}
          </div>
        </div>
        {/* RIGHT SIDE — OPENBETS (30%) */}
        <div className="flex-shrink-0 mr-[10px]" style={{ flexBasis: "25%" }}>
          <OpenBets />
        </div>
      </div>

      {/* Mobile */}
      <div className="grid lg:hidden grid-col-12 relative top-[56px]">
        <div className="col-span-12">
          <ul className="!pl-[6px] !pr-[3px] !py-[0] !w-[100%] mx-[0] my-[3px] flex">
            <li
              className={`rounded-tl-[4px] rounded-br-[0] rounded-tr-[0] rounded-bl-[4px] w-[33%] block [list-style:none] border-[1px] border-[solid] border-[#3b5160] border-[1px_0]`}
            >
              <button
                type="button"
                className={`rounded-tl-[3px] !leading-[8.8vw] font-bold rounded-br-[0] rounded-tr-[0] rounded-bl-[3px] border-l-[1px_#3b5160] w-full !leading-[40px] text-[0.938rem] ${
                  selectedTime == "inplay"
                    ? `bg-[#3B5160] text-[#ffffff]`
                    : `bg-[#ffffff] text-[#3B5160]`
                }`}
                onClick={() => setSelectedTime("inplay")}
              >
                In-Play
              </button>
            </li>

            <li
              className={`rounded-br-[0] rounded-tr-[0]  w-[33%] !leading-[8.8vw] block border-y-[1px] border-[solid] border-[#3B5160] border-[1px_0]`}
            >
              <button
                type="button"
                className={`rounded-tl-[3px] !leading-[8.8vw] font-bold rounded-br-[0] rounded-tr-[0] rounded-bl-[3px] border-l-[1px_#3b5160] w-full !leading-[40px] text-[0.938rem] ${
                  selectedTime == "today"
                    ? `bg-[#3B5160] text-[#ffffff]`
                    : `bg-[#ffffff] text-[#3B5160]`
                }`}
                onClick={() => setSelectedTime("today")}
              >
                Today
              </button>
            </li>

            <li
              className={` rounded-tl-[0] rounded-br-[4px] !leading-[8.8vw] rounded-tr-[4px] rounded-bl-[0] w-[33%] block [list-style:none] border-[1px] border-[solid] border-[#3B5160] border-[1px_0]`}
            >
              <button
                type="button"
                className={`rounded-tl-[3px] !leading-[8.8vw] font-bold rounded-br-[0] rounded-tr-[0] rounded-bl-[3px] border-l-[1px_#3b5160] w-full !leading-[40px] text-[0.938rem] ${
                  selectedTime == "tomorrow"
                    ? `bg-[#3B5160] text-[#ffffff]`
                    : `bg-[#ffffff] text-[#3B5160]`
                }`}
                onClick={() => setSelectedTime("tomorrow")}
              >
                Tomorrow
              </button>
            </li>
          </ul>
        </div>
        {cricketEvents.length > 0 && (
          <div className="col-span-12 mb-[10px]">
            <div className="bg-[linear-gradient(-180deg,_#184438_0%,_#000000_100%)] ">
              <h3 className="bg-[linear-gradient(-180deg,_#184438_0%,_#000000_100%)] text-[#ffffff] text-center  text-[0.875rem] leading-[30px] font-bold pl-[10px] m-0 cursor-pointer">
                Cricket{" "}
              </h3>
            </div>
            <table className="w-full">
              <tbody className="bg-[linear-gradient(-180deg,_#ffffff_0%,_#ffffff_100%)]">
                {cricketEvents.map((event, index) => (
                  <MobileTableRow key={index} row={event} inplay={true} />
                ))}
              </tbody>
            </table>
          </div>
        )}
        {soccerEvents.length > 0 && (
          <div className="col-span-12 mb-[10px]">
            <div className="bg-[linear-gradient(-180deg,_#184438_0%,_#000000_100%)] ">
              <h3 className="bg-[linear-gradient(-180deg,_#184438_0%,_#000000_100%)] text-[#ffffff] text-center  text-[0.875rem] leading-[30px] font-bold pl-[10px] m-0 cursor-pointer">
                Soccer{" "}
              </h3>
            </div>
            <table className="w-full">
              <tbody className="bg-[linear-gradient(-180deg,_#ffffff_0%,_#ffffff_100%)]">
                {soccerEvents.map((event, index) => (
                  <MobileTableRow key={index} row={event} inplay={true} />
                ))}
              </tbody>
            </table>
          </div>
        )}
        {tennisEvents.length > 0 && (
          <div className="col-span-12 mb-[10px]">
            <div className="bg-[linear-gradient(-180deg,_#184438_0%,_#000000_100%)] ">
              <h3 className="bg-[linear-gradient(-180deg,_#184438_0%,_#000000_100%)] text-[#ffffff] text-center  text-[0.875rem] leading-[30px] font-bold pl-[10px] m-0 cursor-pointer">
                Tennis{" "}
              </h3>
            </div>
            <table className="w-full">
              <tbody className="bg-[linear-gradient(-180deg,_#ffffff_0%,_#ffffff_100%)]">
                {tennisEvents.map((event, index) => (
                  <MobileTableRow key={index} row={event} inplay={true} />
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* <div className='col-span-12 overflow-x-auto overflow-y-hidden [scrollbar-width:none]'>
                    <ul className="flex flex-nowrap whitespace-nowrap overflow-x-auto overflow-y-hidden  text-sm font-medium text-center text-gray-500  [scrollbar-width:none] bg-[linear-gradient(-180deg,#14805e_0,_#184438_100%)] " ref={scrollableDivRef}>
                        {Appconfig.casinoNav.map((item, index) => {
                            if (Appconfig.sitecodes != "P56" && item.cainso_type == "WCO") {
                                return null;
                            }
                            return (
                                <li className="flex px-[4px] py-[2px]">
                                    <button id={`item-${index}`} className={`p-[7px] min-w-[60px] text-[0.75rem] font-bold whitespace-nowrap uppercase [transition:color_.15s_ease-in-out,_background-color_.15s_ease-in-out,_border-color_.15s_ease-in-out] ${activeCasino == item.category ? `text-white` : `text-black border-r-[1px] border-black rounded-[40px]`}  `} onClick={(e) => {
                                        scrollToItem(index)
                                        setActiveCasino(item.category)
                                    }}>{item.title}</button>
                                </li>
                            )
                        })}
                    </ul>

                    <div className="grid grid-cols-12 gap-x-4 bg-[url('/public/other/casinobg.webp')] bg-contain bg-fixed p-[0.938rem] border-b-[1px] border-[#7e97a7]">
                        {
                            casino.map((casino) => (
                                <div className='col-span-4 relative  rounded-[5px] mb-[15px] cursor-pointer [box-shadow:0px_2px_4px]'>
                                    <div className='relative h-[90px] bg-[#14805e]  rounded-tl-[3px] rounded-tr-[3px]'>
                                        <div className='clip w-[100%] !h-[100px]'></div>
                                        <div className='clip2 !w-[100%] !left-[0vh]'>
                                            <img title="" alt="" className="w-full h-full" src={casino.path}></img>
                                        </div>
                                    </div>
                                    <div className='casinoFont w-full text-center text-[9px] h-[20px] items-center grid rounded-bl-[3px] rounded-br-[3px] font-bold uppercase bg-[linear-gradient(-180deg,_#14805e_0,_#184438_100%)]'>
                                        {casino.title}
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div> */}
      </div>
    </>
  );
}

export default Inplay;
